import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SHARED_FEATURE_KEY, SharedState } from './shared.reducer';

// Lookup the 'Shared' feature state managed by NgRx
export const getSharedState = createFeatureSelector<SharedState>(SHARED_FEATURE_KEY);

export const getCountryList = createSelector(
  getSharedState,
  (state: SharedState) => state.countryList
);

export const getStatesList = createSelector(
  getSharedState,
  (state: SharedState) => state.stateList
);

export const getPlanList = createSelector(getSharedState, (state: SharedState) => state.planList);

export const getEmailValidation = createSelector(
  getSharedState,
  (state: SharedState) => state.validateEmail
);

export const getApiLoadingStatus = createSelector(
  getSharedState,
  (state: SharedState) => state.isLoaded
);

export const GetClearSearch = createSelector(
  getSharedState,
  (state: SharedState) => state.isClearSearch
);

export const GetAllGridConfigs = createSelector(
  getSharedState,
  (state: SharedState) => state.allGridConfig
);

export const GetGridState = createSelector(getSharedState, (state: SharedState) => state.gridState);
